import { createContext, useContext } from 'react';

export type SankeyAutosaveState = {
  isSaving: boolean;
  lastSaveTimestamp: string | undefined;
  lastSaveError: string | undefined;
};

export const SankeyAutosaveContext = createContext<SankeyAutosaveState>({
  isSaving: false,
  lastSaveTimestamp: undefined,
  lastSaveError: undefined,
});

export const useSankeyAutosaveContext = () => useContext(SankeyAutosaveContext);
